// extracted by mini-css-extract-plugin
export var logo = "_li-2";
export var logoWrapper = "_li-1";
export var strip = "_li-0";